export default "__VITE_ASSET__DgBgRnKl__"